//this file contains functions corresponding to attendee actions 
import 'firebase/firestore';
import 'firebase/auth';
import {firestore as db, timestamp} from './firebaseConfig';

//returns list of maps from each reaction to their count 
export function getGraphData(sessionId){
    var data = [];  
    var collectionName = "meetings/" + sessionId + "/voteCount"
    db.collection(collectionName).onSnapshot((snapshot) => 
        {
            snapshot.forEach((doc) => {
                var info = new Map();
                var reaction = doc.data().reaction;
                var count = doc.data().count;
                info.set(reaction, count);
                data.push(info);
            })
        }
    );

    return data;
}

// returns unique users who submitted a reaction BY reaction 
export async function getUniqueUserbyReaction(sessionId, reaction){
    let arr = await getUniqueReactionsAndUsers(sessionId)

    if(!reaction) return arr[0]
    return arr[0].get(reaction)
}


// returns all unique users who submitted a reaction 
export async function getTotalUniqueReactionUsers(sessionId){
    let arr = await getUniqueReactionsAndUsers(sessionId)
    return arr[1]
}

// helper function to get the unique users 
// returns both and total and unique users per reaction 
async function getUniqueReactionsAndUsers(sessionId){
    var collectionName = "meetings/" + sessionId + "/votes"
    var uniqueUsers = new Set()
    var uniqueReactionsCount = new Map()
    var uniqueReactionsUsers = new Map()
    let reactions =  await db.collection(collectionName).get()

    reactions.forEach((doc) => {
        let reaction = doc.data().reaction
        let user = doc.data().userId
        
        if(user!=undefined){
            if (!uniqueUsers.has(user)){
                uniqueUsers.add(user)
            }

            let uniqueUsersForReaction = uniqueReactionsUsers.get(reaction) 
            if (uniqueUsersForReaction == undefined){
                uniqueUsersForReaction = new Set()
            }

            if (!uniqueUsersForReaction.has(user)){
                //add user to reaction's user list 
                uniqueUsersForReaction.add(user)
                uniqueReactionsUsers.set(reaction, uniqueUsersForReaction)

                //increment count for additional unique user
                uniqueReactionsCount = uniqueReactionsCount.set(reaction, uniqueReactionsCount.get(reaction) + 1 || 1)

            }
        }
    })
    
    let p = [uniqueReactionsCount, uniqueUsers]
    return p
}

// returns a set of the unqiue attendees who participated in the chat for a meeting 
export async function getUniqueMessengers(sessionId){
    let uniqueMessengers = new Set()

    let collectionName = "meetings/" + sessionId + "/messages"
    db.collection(collectionName).onSnapshot((snapshot) => 
        {
            snapshot.forEach((doc) => {
                let isOrganizer = doc.data().fromAdmin
                let sender = doc.data().senderId
                
                if((sender != undefined) && (!isOrganizer)){
                    uniqueMessengers.add(sender)
                }
            })
        }
    );
    return uniqueMessengers
}

//returns the session topic array 
export async function getTopics(sessionId){ 
    let doc = await db.collection("meetings").doc(sessionId).get()
    return await doc.data()?.topics;
}

//returns the session reactions array 
export async function getReactions(sessionId){
    let doc = await db.collection("meetings").doc(sessionId).get()
    let reactions = await doc.data()?.reactions;
    return await reactions;
}

//returns the session reaction color array 
export async function getReactionColors(sessionId){
    let doc = await db.collection("meetings").doc(sessionId).get()
    let colors = await doc.data()?.colors;
    return await colors;
}


//will return a map of the session info 
export async function getSessionInfo(sessionId){

    let doc = await db.collection("meetings").doc(sessionId).get()
    var info = new Map([
        ["name", await doc.data()?.name],
        ["date", await doc.data()?.date],
        ["time", await doc.data()?.time]
      ]);
    return info;
}

export async function numAttendees(sessionId) {
    if(!sessionId) return 0;
    const doc = await db.collection("attendees")
        .where("sessionId", "==", sessionId).get();
    return doc.size;
}

//returns number of active participants
//if interval == null: clicked or texted atleast ONCE during ENTIRE meeting 
//if interval: clicked or texted atleast ONCE during interval 
export async function activeAttendees(sessionId, interval){
    if(!sessionId) return 0;

    const clicks = interval? await db.collection("meetings/" + sessionId + "/votes").where("timestamp", ">=", interval).get() :
                            await db.collection("meetings/" + sessionId + "/votes").orderBy("timestamp", "asc").get();
    const messages = interval? await db.collection("meetings/" + sessionId + "/messages").where("timestamp", ">=", interval).get() 
                            : await db.collection("meetings/" + sessionId + "/messages").orderBy("timestamp", "asc").get();
    let all = [];

    for(const doc of clicks.docs){
        all.push(doc.data()?.userId)
    }

    for(const doc of messages.docs){
        all.push(doc.data()?.userId)
    }

    return [...new Set(all)].length;
}

export async function getAvgMessages(sessionId) {
    if(!sessionId) return 0;
    const clicks = await db.collection("meetings/" + sessionId + "/votes").get();

    const messages = await db.collection("meetings/" + sessionId + "/messages").get();

    const ref = await db.collection("meetings").doc(sessionId).get();
    if(!ref.data().endTime) return 0;

    try { 
    const time = ref.data().time;
    const date = ref.data().date;
    const c = date + " " + time
    const begin = timestamp.fromDate(new Date(c)).seconds;
    const end = ref.data().endTime.seconds;
    //messages.docs.length > 0? messages.docs[0]?.data().timestamp.seconds : 0;
    const mins = (end - begin)/60;

    //firebase stores an extra doc when we initalize a collection
    //subtract extra doc
    return Math.round(((clicks.size - 1) + (messages.size - 1))/mins * 100) / 100;
    }
    catch(e) {
        return 0;
    }
}

export async function getMaxReaction(sessionId) {
    if(!sessionId) return null;
    const snapshot = await db.collection("meetings/" + sessionId + "/voteCount").orderBy("reaction").get();
    const max = {reaction : "", count: 0};

    snapshot.docs?.map((doc) => {
        if(doc.data()?.count >= max.count) {
            max.reaction = doc.data()?.reaction;
            max.count = doc.data()?.count;
        }
    });
    return max.count > 0? max.reaction : "None";
}